import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";
const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsVisible(scrollTop > 200);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button
      style={{
        zIndex: "25",
      }}
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 p-2 sm:w-14 sm:h-14 w-12 h-12 rounded-full bg-[#B87333] text-white shadow-lg flex items-center justify-center font-semibold ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      } hover:bg-pistache transition duration-200`}
      aria-label="Scroll to top"
    >
      <ArrowUp />
    </button>
  );
};

export default ScrollToTop;
